var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"main-header flex-center-between"},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/bd_rowa_rgb.png"),"height":"24"}}),_c('span',{staticClass:"mr-20"},[_vm._v(_vm._s(_vm.user.firstName)+" "+_vm._s(_vm.user.lastName))]),_c('v-main-header-menu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }